import { connectedStore } from '../../store';
import actions from '../actions';

function addCustomTextColor(color) {
  const store = connectedStore.get();
  store.dispatch(actions.addCustomTextColor(color));
}

export default addCustomTextColor;
